document.addEventListener("DOMContentLoaded", () => {
	const alertBar = document.querySelector(".wp-block-zp4-alertbar");

	// Ensure alertBar exists and the alert bar is active before trying to modify it
	if (alertBar && alertBar.getAttribute("data-alertbar-active") === "true" && getCookie("alertBarClosed") !== "true") {
		alertBar.style.display = "block"; // Show the alert bar
	} else {
		alertBar.style.display = "none"; // Hide the alert bar if not active
	}

	// Check for the existence of the close button before adding an event listener
	const closeButton = document.getElementById("closeAlertBarButton");
	if (closeButton) {
		closeButton.addEventListener('click', () => closeAlertBar(alertBar));
	}
});

const closeAlertBar = (alertBar) => {
	if (alertBar) {
		alertBar.style.display = "none"; // Hide the alert bar
		setCookie("alertBarClosed", "true", 1); // Set the cookie for 24 hours
	}
}

const setCookie = (name, value, days) => {
	let expires = "";
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		expires = ";expires=" + date.toUTCString();
	}
	document.cookie = `${name}=${value || ""}${expires};path=/`;
}

const getCookie = (name) => {
	const nameEQ = `${name}=`;
	const ca = document.cookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}
